import { render, staticRenderFns } from "./ComplexList.vue?vue&type=template&id=4bb31e10&scoped=true"
import script from "./ComplexList.vue?vue&type=script&lang=js"
export * from "./ComplexList.vue?vue&type=script&lang=js"
import style0 from "./ComplexList.vue?vue&type=style&index=0&id=4bb31e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb31e10",
  null
  
)

export default component.exports